module.exports = __webpack_public_path__ + "img/holiday.4407262c.png";